export default "__VITE_PUBLIC_ASSET__3504e0af__"